export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/mysql.0d031d2.svg";